// Depends
import { route, group, subGroup, meta } from '@/helpers/routes'

import Create from './form/form'
import Index from './index/index'

const rentRoutes = [
  route('create', '/create', Create, meta('Alugar Vaga', true, 'guest')),
  route('edit', '/:id/edit', Create, meta('Editar Aluguel', true, 'guest')),
  route('index', '/index', Index, meta('Lista de Alugueis', true, 'guest'))
]

export default [
  ...group('/app/rent', [
    ...subGroup('/parking', rentRoutes)
  ])
]



// WEBPACK FOOTER //
// ./src/app/tenant/rent-parking/routes.js